import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'
import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

// Utils

import LoaderWrapper from '../../loaderWrapper'
import Pagination, { PaginationProps } from '../../pagination'
import { ReviewItem, ReviewItemProps } from '../reviewItem'

import styles from './allReviews.module.scss'
import { ReviewsFilter, ReviewsFilterProps } from './ReviewsFilter'

export interface AllReviewsProps {
  reviews: ReviewItemProps[]
  paginationProps: PaginationProps
  className?: string
  filterProps: ReviewsFilterProps
  showReviewsLoader?: boolean
  onReviewImageClick: (reviewId: number, imageIndex: number) => void
  isKidsAndBabyProduct?: boolean
  variants?: any
  productProperties: ProductProperties
}

export const AllReviews = ({ className = '', ...props }: AllReviewsProps) => {
  const { t } = useTranslation('common')
  // if (props.reviews.length <= 0) return <ReviewsFilter {...props.filterProps} />;

  return (
    <div className={classnames(styles.allReviewWrap, className)}>
      <ReviewsFilter {...props.filterProps} variants={props.variants} productProperties={props.productProperties} />
      <LoaderWrapper showLoader={props.showReviewsLoader}>
        {props.filterProps.hasPhoto && props.reviews.length <= 0 ? (
          <div className={styles.allReviews__noPhotoReviewText}>{t('there_are_no_reviews_with_photos_yet')}</div>
        ) : (
          <div className={styles.reviewInnerWrap}>
            {props.reviews.map((reviewItem: ReviewItemProps, index: number) => {
              return (
                <ReviewItem
                  key={index}
                  index={index + (props.paginationProps.page - 1) * 4}
                  {...reviewItem}
                  isKidsAndBabyProduct={props.isKidsAndBabyProduct}
                  className={styles.allReviews__reviewItemWrap}
                  reviewStarsWrapClassName={styles.allReviews__reviewStarsWrap}
                  onReviewImageClick={props.onReviewImageClick}
                />
              )
            })}
          </div>
        )}
      </LoaderWrapper>

      {props.reviews.length > 0 && <Pagination {...props.paginationProps} />}
    </div>
  )
}

export default AllReviews
